import {
  Box,
  Grid,
  Typography,
  Divider,
  IconButton,
} from "@mui/material";
import FacebookIcon from "@mui/icons-material/Facebook";
import TwitterIcon from "@mui/icons-material/Twitter";
import InstagramIcon from "@mui/icons-material/Instagram";
import WhatsAppIcon from "@mui/icons-material/WhatsApp";
import YouTubeIcon from "@mui/icons-material/YouTube";
import { useNavigate } from "react-router-dom";

export default function Footer() {
  const navigate = useNavigate();

  return (
    <Box
      sx={{
        width: "100%",
        // mt: 6,
        bgcolor: "background.default",
        color: "text.primary",
        py: 4,
        borderTop: "1px solid #eee",
        position: "relative",
      }}
    >
      {/* Dotted Background (left side) */}
      <Box
        sx={{
          position: "absolute",
          top: 0,
          left: 0,
          width: { xs: "50%", md: "100%" },
          height: "100%",
          //   backgroundImage:
          //     "radial-gradient(#dcdcdc 1px, transparent 1px)",
          backgroundSize: "12px 12px",
          opacity: 0.4,
          pointerEvents: "none",
        }}
      />

      <Box sx={{ width: "90%", mx: "auto", position: "relative", zIndex: 2 }}>
        <Grid container alignItems="center" sx={{ justifyContent: {xs: "center", md:"center", lg: "space-between"}}}>
          {/* LEFT SIDE */}
          <Grid
            item
            xs={12}
            md={6}
            sx={{ textAlign: { xs: "center", md: "left" } }}
          >
            <Typography
              sx={{
                fontSize: "16px",
                color: "text.primary",
                mt: { xs: 2, md: 0 },
                lineHeight: 1.8,
                "& a": {
                  color: "inherit",
                  textDecoration: "underline",
                  "&:hover": {
                    color: "#ff184e",
                  },
                },
              }}
            >
              © {new Date().getFullYear()} <span style={{ color: "#ff184e" }}>JanpatNews24.</span> All Rights Reserved. Design And Develop By <a href="https://cubemoons.com" target="_blank" rel="noopener noreferrer">Cubemoons.com</a>
            </Typography>
          </Grid>

          {/* RIGHT SIDE */}
          <Grid
            item
            xs={12}
            md={6}
            sx={{
              display: "flex",
              flexDirection: { xs: "column", sm: "row" },
              justifyContent: { xs: "center", sm: "flex-end" },
              alignItems: "center",
              gap: 2,
              mt: { xs: 3, md: 0 },
            }}
          >
            <Typography 
              onClick={() => navigate('/about-us')} 
              sx={{ fontSize: "16px", fontWeight: 600, textAlign: "center", cursor: "pointer", "&:hover": { color: "#ff184e" } }}
            >
              About Us
            </Typography>
            <Typography sx={{ fontSize: "16px", fontWeight: 600, textAlign: "center" }}>
              Follow US
            </Typography>

            <Box sx={{ display: "flex", gap: 1.5, flexWrap: "wrap", justifyContent: "center" }}>
              {[
                { icon: <FacebookIcon fontSize="small" />, key: "facebook" },
                { icon: <TwitterIcon fontSize="small" />, key: "twitter" },
                { icon: <InstagramIcon fontSize="small" />, key: "instagram" },
                { icon: <WhatsAppIcon fontSize="small" />, key: "whatsapp" },
                { icon: <YouTubeIcon fontSize="small" />, key: "youtube" },
              ].map((item) => (
                <IconButton
                  key={item.key}
                  sx={{
                    backgroundColor: "#000",
                    color: "#fff",
                    width: 32,
                    height: 32,
                    "&:hover": {
                      backgroundColor: "#000",
                      color: "#ff184e",
                    },
                  }}
                >
                  {item.icon}
                </IconButton>
              ))}
            </Box>
          </Grid>
        </Grid>

        <Divider sx={{ mt: 3 }} />
      </Box>
    </Box>
  );
}
